import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Box, Button, CircularProgress, Sheet, Stack, Typography } from "@mui/joy";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import mammoth from "mammoth";


export default function PrivacyPolicyPage() {
    const navigate = useNavigate();
    const [html, setHtml] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("./privacy-policy.docx")
            .then(r => r.arrayBuffer())
            .then(buf => mammoth.convertToHtml({ arrayBuffer: buf }))
            .then(result => setHtml(result.value))
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, []);

    return (
        <Box sx={{
            minHeight: "100dvh",
            bgcolor: "background.body",
            py: { xs: 2, md: 4 },
            px: { xs: 2, md: 3 },
        }}>
            <Box sx={{ maxWidth: 900, mx: "auto" }}>
                {/* Шапка */}
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ mb: 2 }}
                >
                    <Button
                        onClick={() => navigate(-1)}
                        startDecorator={<ArrowBackRoundedIcon />}
                        variant="soft"
                        color="neutral"
                        sx={{ borderRadius: "lg" }}
                    >
                        Назад
                    </Button>
                    <Typography level="title-lg" sx={{ fontWeight: 700 }}>
                        Политика конфиденциальности
                    </Typography>
                    <Box sx={{ width: 100 }} /> {/* spacer для баланса */}
                </Stack>

                {/* Контент */}
                <Sheet
                    sx={{
                        p: { xs: 2.5, md: 4 },
                        borderRadius: "xl",
                        border: "1px solid",
                        borderColor: "divider",
                        boxShadow: "0 4px 24px rgba(87, 42, 195, 0.06)",
                        minHeight: 400,
                    }}
                >
                    {loading && (
                        <Stack alignItems="center" spacing={2} sx={{ py: 6 }}>
                            <CircularProgress size="lg" color="primary" />
                            <Typography level="body-md" sx={{ color: "text.tertiary" }}>
                                Загрузка документа...
                            </Typography>
                        </Stack>
                    )}

                    {error && !loading && (
                        <Stack alignItems="center" spacing={1} sx={{ py: 6 }}>
                            <Typography level="title-md" color="danger">
                                Ошибка загрузки
                            </Typography>
                            <Typography level="body-sm" sx={{ color: "text.tertiary" }}>
                                {error}
                            </Typography>
                        </Stack>
                    )}

                    {!loading && !error && (
                        <Box
                            className="privacy-policy-content"
                            sx={{
                                "& h1, & h2, & h3": { fontWeight: 700, mt: 2.5, mb: 1.5 },
                                "& h1": { fontSize: "1.6rem" },
                                "& h2": { fontSize: "1.3rem" },
                                "& h3": { fontSize: "1.1rem" },
                                "& p":  { mb: 1.2, lineHeight: 1.6, fontSize: "0.95rem" },
                                "& ul, & ol": { pl: 3, mb: 1.5 },
                                "& li": { mb: 0.5, lineHeight: 1.6 },
                                "& a":  { color: "primary.500" },
                                "& table": {
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    my: 2,
                                },
                                "& td, & th": {
                                    border: "1px solid",
                                    borderColor: "divider",
                                    p: 1,
                                },
                            }}
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    )}
                </Sheet>
            </Box>
        </Box>
    );
}